import { useDisclosure, VStack } from '@chakra-ui/react';
import { type FC, useState } from 'react';

import { DeleteTeacherModal } from '$/pages/SchoolPage/components/DeleteTeacherModal';
import { TeacherCard } from '$/pages/SchoolPage/components/TeacherCard';
import { type User } from '$/services/usecases/authentication/mapper/genericCloudResponse';

interface Props {
  teachers: User[];
}

export const TeacherCardList: FC<Props> = ({ teachers }) => {
  const deleteModal = useDisclosure();

  const [selectedTeacher, setSelectedTeacher] = useState<User | null>(null);

  const handleDelete = (teacher: User) => {
    setSelectedTeacher(teacher);
    deleteModal.onOpen();
  };

  return (
    <>
      <VStack w='full'>
        {teachers.map((teacher) => (
          <TeacherCard
            key={teacher.id}
            teacher={teacher}
            onDelete={handleDelete}
          />
        ))}
      </VStack>

      {selectedTeacher != null && (
        <DeleteTeacherModal
          teacher={selectedTeacher}
          isOpen={deleteModal.isOpen}
          onClose={deleteModal.onClose}
        />
      )}
    </>
  );
};
